import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
//import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    siteTitle: 'siteTitle',
    lang: 'ru',
    locale: 'RU-ru',
    currency: '₽',
    first_day_of_week: 1,
    languages: [
      {
        name: 'Русский',
        image: 'https://levam.net/images/flags/ru.png',
        locale: 'ru'
      },
      {
        name: 'English',
        image: 'https://levam.net/images/flags/en.png',
        locale: 'en'
      },
      {
        name: "Española",
        image: 'https://levam.net/images/flags/es.png',
        locale: 'es'
      },
      {
        name: "Polski",
        image: 'https://levam.net/images/flags/pl.png',
        locale: 'pl'
      },
      {
        name: "Deutsch",
        image: 'https://levam.net/images/flags/de.png',
        locale: 'de'
      },
      {
        name: "Française",
        image: 'https://levam.net/images/flags/fr.png',
        locale: 'fr'
      },
    ],
    isFetching: false,
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    setLangAndCurrency(state, data){
      state.lang = data.lang;
      //i18n.locale = data.lang

      switch (data.lang) {
        case 'ru':
          state.locale = 'RU-ru'
          break;
        case 'en':
          state.locale = 'EN-us'
          break;
        case 'es':
          state.locale = 'ES-es'
          break;
        case 'pl':
          state.locale = 'PL-pl'
          break;
        case 'de':
          state.locale = 'DE-de'
          break;
        case 'fr':
          state.locale = 'FR-fr'
          break;
        default:
          this._vm.$error( "Unknown language: "+data.lang )
          break;
      }
    }
  },
  actions: {
    async setLangAndCurrency({ commit, state, dispatch }, payload) {
      commit("setLangAndCurrency", {
        lang: payload
      });
    },
    async getLangByEmail({ commit, state, dispatch }, payload) {
      updateField(state, {path: 'isFetching', value: true});
      return await axios
          .get(this._vm.$apiURL + "/i18n/lang-by-email", { params: {email: payload} })
          .then((response) => {
            return response.data && response.data.data || 'en';
          })
          .catch((error) => {
            return 'en';
          })
          .finally(()=>{
            updateField(state, {path: 'isFetching', value: false});
          })
    }

  }
}
